import { type ChangeEvent, useState } from "react";
import { toast } from "react-toastify";
import { ContentContainer, FileInput, Loader, widthStyles } from "ui";
import { uploadImage } from "../../../store";

interface Props {
  onUpload: (imageUrl: string) => void;
}

export function NewImage({ onUpload }: Props) {
  const [uploading, setUploading] = useState(false);

  const onSelectFile = async (e: ChangeEvent<HTMLInputElement>) => {
    if (!e.target || !e.target.files) {
      return;
    }

    const file = e.target.files[0];
    setUploading(true);
    try {
      const { fileUrl: uploadedFile } = await uploadImage(file);
      onUpload(uploadedFile);
    } catch (error) {
      const {
        response: {
          data: { message },
        },
      } = error as { response: { data: { message: string } } };
      if (message) {
        toast.error(message);
      }
    } finally {
      setUploading(false);
    }
  };

  return (
    <ContentContainer
      onClick={() => {}}
      forcePrompt={!uploading}
      iconType="Image"
      label="Add an image"
      className={widthStyles.full}
    >
      {uploading ? <Loader /> : <FileInput disabled={uploading} onSelectFile={onSelectFile} type="image" />}
    </ContentContainer>
  );
}
